/*
	1R Scripts Entry
*/
import './public-path';

import route from './router';

import '../styles/style.scss';

console.log('ORW Index JS loaded');

route();
